<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <visitor-check-in-page /><br><br><br>
    </div>
  </div>
</template>

<script>
import VisitorCheckInPage from '../../../Components/Visitor/VisitorCheckInPage.vue';
  export default {
    name: 'VisitorCheckInPage',
    components: {
      'visitor-check-in-page': VisitorCheckInPage,
  },
};
</script>

<style scoped>

</style>
